import { IPagination } from 'app/types/common';

export interface IPayment {
  id: string;
  type: string;
  description: string;
  amount: number;
  dueAt: Date;
  createdAt: Date;
  updatedAt: Date;
  status: string;
  collected: number;
  deductedAmount: number;
  pending: number;
  pendingAmount: number;
  totalAmount: number;
  collectedAmount: number;
  total: number;
  numberOfTeams: number;
  numberOfTeamMembers: number;
  teamPaymentRequestType: string;
  teamPaymentRequestCategory: string;
  metadata: any;
  notificationLog: any;
  notificationConfiguration?: any;
  teams: {
    id: string;
    type: string;
    name: string;
    sport: string;
    userId: string;
    organisationId?: any;
    inviteToken: string;
    createdAt: Date;
    updatedAt: Date;
    status?: any;
    financialStatus: string;
    pendingTeamPaymentCollectionsTotalCount: number;
    paidTeamPaymentCollectionsTotalCount: number;
    overdueTeamPaymentCollectionsTotalCount: number;
    pendingTeamPaymentCollectionsTotalAmount: number;
    paidTeamPaymentCollectionsTotalAmount: number;
    overdueTeamPaymentCollectionsTotalAmount: number;
    numberOfTeamMembers: number;
  }[];
}

export interface ITeamPaymentRequest {
  id: string;
  type: string;
  description: string;
  amount: number;
  dueAt: string;
  createdAt: string;
  updatedAt: string;
  status: string;
  collected: number;
  pending: number;
  pendingAmount: number;
  totalAmount: number;
  collectedAmount: number;
  total: number;
  numberOfTeams: number;
  numberOfTeamMembers: number;
  teamPaymentRequestType: string;
  teamPaymentRequestCategory: string;
  metadata: {};
  notificationLog: {
    sendSmsInitialNotificationTeamMembers: {
      sent: boolean;
      sentOn: string;
    };
    sendEmailInitialNotificationTeamMembers: {
      sent: boolean;
      sentOn: string;
    };
    sendSmsDueReminderTeamMembers: {
      sent: boolean;
      sentOn: string;
    };
    sendEmailDueReminderTeamMembers: {
      sent: boolean;
      sentOn: string;
    };
  };
  notificationConfiguration?: {
    sendSmsInitialNotificationTeamMembers: boolean;
    sendEmailInitialNotificationTeamMembers: boolean;
    sendSmsDueReminderTeamMembers: boolean;
    sendEmailDueReminderTeamMembers: boolean;
  };
}

export interface ITeamPaymentRequestsState {
  readonly teamPaymentRequestsById?: any;
  readonly teamPaymentRequestIds?: string[];
  readonly hasSaved?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly showAddPayment?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationPaymentIds?: string[];
  readonly currentTeamPaymentRequestId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
  error?: string;
  state: {
    paymentType: any;
    splitType: any;
    description: string;
    amount: string;
    dueDate: string;
  };
  payeeType: string;
  selectedTeamMembersIds: string[];
  selectedTeamMembersById: any;
  selectedAllRows: boolean;
  selectedRowIds: string[];
  selectedRows: any;
  selectedRowsById: any;
  // errors: any;
  // changed: boolean;
  // saved: boolean;
  originalFormData: {
    paymentType: any;
    splitType: any;
    description: string;
    amount: string;
    dueDate: string;
  };
  formData: any;
  changed: boolean;
  saved: boolean;
  errors: any;
  teamMemberRows?: any[];
}

export interface ITeamPaymentRequestsSelector extends ITeamPaymentRequestsState {
  readonly currentTeamPaymentRequest?: any;
  readonly currentFormTeamPaymentRequest?: any;
  readonly getPaymentsFilteredByTagInSelectFormat?: any;
  readonly teamPaymentRequestsByIdInSelectFormat?: any;
}

export enum TeamPaymentRequestsActionTypes {
  CLEAR_PAYMENT_REQUEST = 'redux-app/team-payment-requests/CLEAR_PAYMENT_REQUEST',
  UPDATE_PAYMENT_REQUEST = 'redux-app/team-payment-requests/UPDATE_PAYMENT_REQUEST',
  GET_ALL_TEAM_PAYMENT_REQUESTS_REQUESTED = 'redux-app/team-payment-requests/GET_ALL_TEAM_PAYMENT_REQUESTS_REQUESTED',
  GET_ALL_TEAM_PAYMENT_REQUESTS_PENDING = 'redux-app/team-payment-requests/GET_ALL_TEAM_PAYMENT_REQUESTS_PENDING',
  GET_ALL_TEAM_PAYMENT_REQUESTS_SUCCESS = 'redux-app/team-payment-requests/GET_ALL_TEAM_PAYMENT_REQUESTS_SUCCESS',
  GET_ALL_TEAM_PAYMENT_REQUESTS_FAIL = 'redux-app/team-payment-requests/GET_ALL_TEAM_PAYMENT_REQUESTS_FAIL',
  GET_TEAM_PAYMENT_REQUEST_REQUESTED = 'redux-app/team-payment-requests/GET_TEAM_PAYMENT_REQUEST_REQUESTED',
  GET_TEAM_PAYMENT_REQUEST_PENDING = 'redux-app/team-payment-requests/GET_TEAM_PAYMENT_REQUEST_PENDING',
  GET_TEAM_PAYMENT_REQUEST_SUCCESS = 'redux-app/team-payment-requests/GET_TEAM_PAYMENT_REQUEST_SUCCESS',
  GET_TEAM_PAYMENT_REQUEST_FAIL = 'redux-app/team-payment-requests/GET_TEAM_PAYMENT_REQUEST_FAIL',
  UPDATE_TEAM_PAYMENT_REQUEST_REQUESTED = 'redux-app/team-payment-requests/UPDATE_TEAM_PAYMENT_REQUEST_REQUESTED',
  UPDATE_TEAM_PAYMENT_REQUEST_PENDING = 'redux-app/team-payment-requests/UPDATE_TEAM_PAYMENT_REQUEST_PENDING',
  UPDATE_TEAM_PAYMENT_REQUEST_SUCCESS = 'redux-app/team-payment-requests/UPDATE_TEAM_PAYMENT_REQUEST_SUCCESS',
  UPDATE_TEAM_PAYMENT_REQUEST_FAIL = 'redux-app/team-payment-requests/UPDATE_TEAM_PAYMENT_REQUEST_FAIL',
  CREATE_TEAM_PAYMENT_REQUEST_REQUESTED = 'redux-app/team-payment-requests/CREATE_TEAM_PAYMENT_REQUEST_REQUESTED',
  CREATE_TEAM_PAYMENT_REQUEST_PENDING = 'redux-app/team-payment-requests/CREATE_TEAM_PAYMENT_REQUEST_PENDING',
  CREATE_TEAM_PAYMENT_REQUEST_SUCCESS = 'redux-app/team-payment-requests/CREATE_TEAM_PAYMENT_REQUEST_SUCCESS',
  CREATE_TEAM_PAYMENT_REQUEST_FAIL = 'redux-app/team-payment-requests/CREATE_TEAM_PAYMENT_REQUEST_FAIL',
  DELETE_TEAM_PAYMENT_REQUEST_REQUESTED = 'redux-app/team-payment-requests/DELETE_TEAM_PAYMENT_REQUEST_REQUESTED',
  DELETE_TEAM_PAYMENT_REQUEST_PENDING = 'redux-app/team-payment-requests/DELETE_TEAM_PAYMENT_REQUEST_PENDING',
  DELETE_TEAM_PAYMENT_REQUEST_SUCCESS = 'redux-app/team-payment-requests/DELETE_TEAM_PAYMENT_REQUEST_SUCCESS',
  DELETE_TEAM_PAYMENT_REQUEST_FAIL = 'redux-app/team-payment-requests/DELETE_TEAM_PAYMENT_REQUEST_FAIL',
  SELECT_TEAM_PAYMENT_REQUEST_REQUESTED = 'redux-app/team-payment-requests/SELECT_TEAM_PAYMENT_REQUEST_REQUESTED',
}

export default null;
